(function () {

    'use strict';

    angular.module('iplusjs.filter.moneyString', [
        'iplusjs.utils.misc',
        'iplusjs.utils.money'
    ])
    .filter('moneyString', MoneyString);

    MoneyString.$inject = [
        'MoneyUtilsService',
        'MiscUtilsService'
    ];
    function MoneyString(MoneyUtilsService, MiscUtilsService) {
        return function (money, currency, currencyPosition, decimal, zeroMoneySubstitutionText, zeroMoneySubstitutionOnlyForEmpty) {
            if (MiscUtilsService.isEmpty(money) || typeof money !== 'object') {
                return zeroMoneySubstitutionText || '';
            }
            return MoneyUtilsService.toMoneyString(money, {
                currency: currency,
                currencyPosition: currencyPosition,
                decimal: decimal,
                zeroMoneySubstitution: zeroMoneySubstitutionText,
                zeroMoneySubstitutionOnlyForEmpty: zeroMoneySubstitutionOnlyForEmpty
            });
        };
    }
})();
